<template>
  <div>
    <div id="donation">
      <div class="donation-box">
        <div class="donation-nav">
          <span>您的位置：首页 ></span>
          <i>捐赠信息</i>
        </div>
        <div class="donation-info">
          <div class="info-box">
            <div class="top-title">
              <div class="title-box">
                <span>捐赠信息</span>
                <i>数据截至{{year}}年底</i>
              </div>
            </div>
            <ul>
              <li>
                <b>{{currentSum}}</b>
                <span>元</span>
                <p>累计公益收入总额</p>
              </li>
              <li>
                <b>{{lastSum}}</b>
                <span>元</span>
                <p>上一年度收入总额</p>
              </li>
              <li>
                <b>{{lastSpend}}</b>
                <span>元</span>
                <p>上一年度公益支出总额</p>
              </li>
            </ul>

            <div class="list-box">
              <ul>
                <li style="font-weight:bold;">
                  <p>捐赠人/企业</p>
                  <span style="color:#333">捐赠金额</span>
                  <span style="color:#333">捐赠时间</span>
                </li>
                <li v-for="(item,index) in DonationList.data" :key="index">
                  <p style="color:#666">
                    <!-- <span class="yuandian"></span> -->
                    {{item.display_name}}
                  </p>
                  <span style="color:#c30d23">{{item.money}} 元</span>
                  <span>{{item.date_time}}</span>
                </li>
              </ul>
              <div class="page-box" v-if="DonationList.total > $db.config.newsListSize2">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  @current-change="handleCurrentChange"
                  :current-page.sync="DonationList.current_page"
                  :page-size="$db.config.newsListSize2"
                  :total="DonationList.total"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
        <div style="height:100px"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      year: null,
      info: 0,
      DonationList: [],
      currentSum: 0,
      lastSum: 0,
      lastSpend: 0
    };
  },
  methods: {
    //千分化金额
    setMoneyFormat(num) {
      num = num + '';
      if (!num.includes('.')) {
        num += '.'
      }
      return num.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
        return $1 + ',';
      }).replace(/\.$/, '');
    },

    handleCurrentChange(page) {
      if (page > 0) {
        this.getDonationList(page);
      }
    },

    //获取捐赠数据列表
    getDonationList(page = 1) {
      this.$db
        .post(this.$db.config.indexDonationList, {
          page: page,
          page_size: this.$db.config.newsListSize2
        })
        .then(res => {
          this.DonationList = res.data.list;
          console.log(res.data.sum,"res")
          this.currentSum = this.setMoneyFormat(res.data.sum);
          this.lastSum = this.setMoneyFormat(res.data.lastyear_in);
          this.lastSpend = this.setMoneyFormat(res.data.lastyear_out);
        });
    }
  },
  mounted() {
    this.getDonationList(1);
  }
};
</script>
<style lang="scss" scoped>
#donation {
  width: 100%;
  background-color: #f8f8f8;
}
.donation-box {
  width: 1300px;

  margin: 0 auto;
}
.donation-nav {
  padding: 20px 0;
  text-align: right;
  > span {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #999999;
  }
  > i {
    font-style: normal;
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0px;
    color: #333333;
  }
}
.donation-info {
  width: 100%;
  background-color: #fff;
  .info-box {
    padding: 20px 30px;
    .list-box {
      margin: 0 auto;
      > ul {
        margin-top: 20px;
        > li {
          display: flex;
          justify-content: space-between;
          padding: 20px;
          /*transition: ease-out 0.6s;
          cursor: pointer;
          &:hover {
            background-color: #c30d23;
            > p {
              color: #fff;
              > .yuandian {
                display: inline-block;
                width: 8px;
                height: 8px;
                background-color: #fff;
                border-radius: 50%;
              }
            }
            > span {
              color: #fff;
            }
          }*/
          > p {
            font-size: 16px;
            color: #333;
            width: 65%;
            /*> .yuandian {
              display: inline-block;
              width: 8px;
              height: 8px;
              background-color: #000;
              border-radius: 50%;
              margin-right: 5px;
              margin-bottom: 1.5px;
            }
            */
          }
          > span {
            font-size: 16px;
            color: #999;
            width: 25%;
            text-align: right;
          }
        }
      }
      .page-box {
        text-align: center;
        margin-bottom: 70px;
      }
    }
    .page-box
      /deep/
      .el-pagination.is-background
      .el-pager
      li:not(.disabled).active {
      background-color: #c30d23;
      color: #fff;
    }
    .page-box /deep/ .el-pagination.is-background .el-pager li {
      background-color: #fff;
      border: solid 1px #dddddd;
      color: #999;
    }
    .page-box
      /deep/
      .el-pagination.is-background
      .el-pager
      li:not(.disabled):hover {
      color: #c30d23;
    }
    .top-title {
      padding: 28px 0;
      display: flex;
      justify-content: space-between;
      .title-box {
        > span {
          font-size: 18px;
          color: #000;
          padding-right: 8px;
        }
        > i {
          font-style: normal;
          font-size: 14px;
          color: #999;
          line-height: 24px;
        }
      }
      > p {
        font-size: 14px;
        color: #000;
        line-height: 26px;
      }
    }
    > ul {
      display: flex;
      justify-content: space-between;
      padding-right: 10px;
      padding-bottom: 30px;
      border-bottom: 1px dashed #eee;
      > li {
        list-style: none;
        > b {
          font-size: 20px;
          color: #c30d23;
        }
        > span {
          font-size: 14px;
          color: #c30d23;
        }
        > p {
          font-size: 14px;
          color: #666;
          padding-top: 4px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Donation/donation_info.vue